@use '@design/design-tokens/typography/typography' as *;

.sectionRow {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.titleMedium {
  @include typography-v2-title-md;
}

.bodySmall {
  @include typography-v2-body-sm;
}

.stepperWrapper {
  width: 100%;
  height: 76px;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  padding: 18px;
}
